'use client';

import Image from 'next/image';
import React from 'react';

export type ImageCardContentProps = {
  rawSrc: string;
  label: string;
  isDefaultImage: boolean;
  description: string;
};

const ImageCardContent: React.FC<ImageCardContentProps> = ({
  rawSrc,
  label,
  isDefaultImage,
  description,
}) => (
  <>
    <div
      className={['image-card-media', isDefaultImage ? 'is-default-image' : '']
        .filter(Boolean)
        .join(' ')}
    >
      <Image
        src={rawSrc}
        alt={label}
        fill
        sizes='(max-width: 768px) 100vw, 220px'
        style={{ objectFit: isDefaultImage ? 'contain' : 'cover' }}
        unoptimized={rawSrc.toLowerCase().endsWith('.svg')}
      />
    </div>
    <div className='image-content'>
      <h3 className='image-title'>{label}</h3>
      {description ? <p className='image-description'>{description}</p> : null}
    </div>
  </>
);

export default ImageCardContent;
